import { render, staticRenderFns } from "./ProductsImg.vue?vue&type=template&id=00d21570&"
import script from "./ProductsImg.vue?vue&type=script&lang=js&"
export * from "./ProductsImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports